const Check = ({ ...props }) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="8"
        height="6"
        viewBox="0 0 8 6"
        fill="none"
        {...props}
    >
        <path d="M1 3L3 5L7 1" stroke="currentColor" />
    </svg>
);
export default Check;
